module.exports = __webpack_public_path__ + "static/media/workoutShoulders.334d0287.png";